import { CountryCodeType } from "utils/constants";

export interface TermsResponse {
  url: string;
  version: string;
  updatedAt: string;
}

export const fetchLatestTerms = async (countryCode: CountryCodeType, appVersion: string): Promise<TermsResponse> => {
  const apiUrl = process.env.REACT_APP_BFF_API_URL;
  
  if (!apiUrl) {
    throw new Error("REACT_APP_BFF_API_URL no configurada.");
  }

  const url = `${apiUrl}/terms/latest`;

  const response = await fetch(url, {
    headers: {
      "country-code": countryCode,
      "app-version": appVersion,
      "Content-Type": "application/json",
    },
  });
  
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ message: response.statusText }));
    throw new Error(`Error al obtener términos y condiciones: ${response.status} ${errorData.message || response.statusText}`);
  }
  
  return response.json();
};

